import { useState } from 'react';

interface UseServerPaginationProps {
  totalCount: number;
  itemsPerPage?: number;
}

export function useServerPagination({ totalCount, itemsPerPage = 10 }: UseServerPaginationProps) {
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.ceil(totalCount / itemsPerPage);
  const from = (currentPage - 1) * itemsPerPage;
  const to = from + itemsPerPage - 1;

  const goToPage = (page: number) => {
    setCurrentPage(Math.max(1, Math.min(page, totalPages || 1)));
  };

  const resetPage = () => setCurrentPage(1);

  return {
    currentPage,
    totalPages,
    totalItems: totalCount,
    from,
    to,
    goToPage,
    resetPage,
    itemsPerPage,
  };
}
